export default class FaturamentoRels2 {

    constructor(resource) {
        this._resource = resource('FaturamentoRelatorio2_supo');
    }

    getClientesSMnt(referencia) {
        return this._resource
            .get(
                {
                    referencia: referencia,
                })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getExtratoSMnt(referencia, id) {
        return this._resource
            .get(
                {
                    referencia: referencia,
                    id: id
                })
            .then(res => res.bodyText
                , err => {
                    throw new Error(err.statusText)
                });
    }

}